// @ts-strict-ignore
import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    color: theme.palette.error.main,
    animation: `${keyframes`
      from { opacity: 0 }
      to { opacity: 1 }
    `} 0.5s ease`,
    marginBottom: theme.spacing(2),
  },
}))
